import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09447a4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "form" }
const _hoisted_4 = { class: "form-title" }
const _hoisted_5 = { class: "form-item" }
const _hoisted_6 = { class: "label" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { class: "form-item" }
const _hoisted_10 = { class: "label" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "value" }
const _hoisted_13 = { class: "form-item" }
const _hoisted_14 = { class: "label" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "value" }
const _hoisted_17 = { class: "form-item" }
const _hoisted_18 = { class: "label" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "value" }
const _hoisted_21 = { class: "form-item" }
const _hoisted_22 = { class: "label" }
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "value" }
const _hoisted_25 = {
  key: 1,
  class: "form-item"
}
const _hoisted_26 = { class: "label" }
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "value" }
const _hoisted_29 = { class: "form-title" }
const _hoisted_30 = { class: "form-item" }
const _hoisted_31 = { class: "label" }
const _hoisted_32 = ["src"]
const _hoisted_33 = { class: "value" }
const _hoisted_34 = {
  key: 2,
  class: "form-item"
}
const _hoisted_35 = { class: "label" }
const _hoisted_36 = ["src"]
const _hoisted_37 = { class: "value" }
const _hoisted_38 = {
  key: 1,
  class: "no-data"
}
const _hoisted_39 = { class: "form-item" }
const _hoisted_40 = { class: "label" }
const _hoisted_41 = ["src"]
const _hoisted_42 = { class: "value" }
const _hoisted_43 = { class: "form-item" }
const _hoisted_44 = { class: "label" }
const _hoisted_45 = ["src"]
const _hoisted_46 = { class: "value" }

import { computed, reactive, ref, watch } from 'vue';
import { Select, Modal, message } from 'ant-design-vue';
import { useVueI18n } from '@/hooks';
import { ExclamationCircleFilled } from '@ant-design/icons-vue';
import { OrderListItem } from '@/api/aws/type';
import { getOrganizationList } from '@/api/organization/index';
import { createGetAppsListApi } from '@/api/role/index';
import { SubApps } from '@/api/role/type';
import { DefaultOptionType } from 'ant-design-vue/lib/vc-select/Select';
import IpSelect from './IpSelect.vue';
import { orderCreate } from '@/api/bill';
import { getIpPublist, getDomail, getAppList } from '@/api/aws/index';
import { AppItem } from '@/types/email-types';

type SelectOptions = { label: string; value: string }[];

export default /*#__PURE__*/_defineComponent({
  __name: 'amazon-bind-modal',
  props: {
    visible: { type: Boolean },
    data: {}
  },
  emits: ['update:visible', 'bindSuccess'],
  setup(__props: any, { emit: emits }) {

const props = __props;

const { t } = useVueI18n();



const model = reactive({
  orderId: props.data.id,
  orgId: '',
  appKey: '',
});

const visible = ref(props.visible);
const loading = ref(false);
const isVerification = ref(false);
const handleOk = () => {
  if (isShowCreate.value) {
    jumpApp();
    return;
  }
  let obj = {} as any;
  if (props.data.business === 'Email') {
    if (props.data.emailOrderDetail?.ipPackageNum) {
      if (ipData.ipList.every(item => item.ip && item.ipArea && item.domain)) {
        isVerification.value = false;
      } else {
        isVerification.value = true;
        return;
      }
    }
    ipData.ipList.forEach(item => {
      item.ipId = getIpId(item.ip);
    });
    obj.details = [
      {
        service: '1', // 邮件包
        num: props.data.emailOrderDetail?.emailPackageNum, // 1000封，对应emailPackageNum
      },
      {
        service: '2', // 流量包
        num: props.data.emailOrderDetail?.flowPackageNum, // 20GB，对应flowPackageNum
      },
      ...ipData.ipList,
    ];
  }
  if (['WebPush', 'AppPush'].includes(props.data.business)) {
    obj.pushOrderDetail = {
      totalDau: props.data.pushOrderDetail?.dau,
    };
  }
  const appName = appList.value.find(item => item.value === model.appKey)?.label;
  orderCreate({
    ...props.data,
    amazonOrderId: model.orderId,
    orgId: model.orgId,
    appId: model.appKey,
    appName,
    details: obj.details,
    pushOrderDetail: obj.pushOrderDetail,
  } as any).then(res => {
    message.success(t('aws.bind.success'));
    emits('bindSuccess');
    emits('update:visible', false);
  });
};
const organizationList = ref([] as DefaultOptionType[]);
const appList = ref([] as DefaultOptionType[]);
const GetOrganizationList = () => {
  getOrganizationList({
    pageIndex: 1,
    pageSize: 1000,
    keyword: '',
  }).then(res => {
    if (res.code === 0 && res.data.list?.length) {
      organizationList.value = res.data.list.map(item => {
        return {
          label: item.name,
          value: item.id,
        };
      });
      model.orgId = organizationList.value[0].value as string;
    } else {
      organizationList.value = [];
    }
  });
};

const successCallback = (res: any) => {
  let resp = [] as any[];
  resp = res.apps!;
  if (props.data.business === 'OTP' || props.data.business === 'NEWSMS') {
    resp = res as any;
  } else if (props.data.business === 'WhatsApp') {
    resp = res.waba_list as any;
  } else if (props.data.business === 'Email') {
    try {
      const parsedRes = typeof res === 'string' ? JSON.parse(res) : res;
      resp = parsedRes?.data?.userDcs || [];
    } catch (error) {
      console.error('Email data parsing failed:', error);
      resp = [];
    }
  }
  if (resp?.length) {
    appList.value = resp
      .filter((item: any) =>
        ['AppPush', 'WebPush'].includes(props.data.business)
          ? item.dcName === props.data.pushOrderDetail?.dcName
          : item,
      )
      .map(item => {
        return {
          label: props.data.business === 'Email' ? item.serviceName : item.name,
          value: ['OTP', 'WhatsApp', 'NEWSMS'].includes(props.data.business)
            ? item.id
            : props.data.business === 'Email'
            ? item.serviceId
            : item.appKey,
        };
      });
    if (appList.value.length) {
      model.appKey = appList.value[0].value as string;
    } else {
      model.appKey = '';
    }
  } else {
    appList.value = [];
  }
};

const businessName = computed(() => {
  return props.data.business === 'NEWSMS' ? 'SMS' : props.data.business;
});

const CreateGetAppsListApi = () => {
  if (['AppPush', 'WebPush'].includes(props.data.business)) {
    getAppList(props.data.business === 'WebPush', model.orgId).then(res => {
      successCallback(res);
    });
    return;
  }
  createGetAppsListApi(props.data.business as any, model.orgId).then((res: SubApps) => {
    successCallback(res);
  });
};

const getDefaultValue = () => {
  return {
    domainList: [] as SelectOptions,
    localList: [] as SelectOptions,
    domail: undefined as string | undefined,
    local: undefined as string | undefined,
    ip: undefined as string | undefined,
    transformIpList: {} as Record<string, string[]>,
    ipList: [] as any[],
    disableList: [] as string[],
  };
};
const ipData = reactive(getDefaultValue());
const disableList = computed(() => {
  return ipData.ipList.map(item => item.ip).filter(item => item);
});
const getVerificationStatus = (record: any) => {
  if (isVerification.value) {
    if (record.ip && record.ipArea && record.domain) {
      return false;
    } else {
      return true;
    }
  }
};
const orignIpList = ref([] as any[]);
const getIpId = (ip: string) => {
  const data = orignIpList.value.find(item => item.ip === ip);
  if (data) {
    return data.ipId;
  }
  return '';
};
const getIpData = () => {
  getIpPublist(model.orgId).then(res => {
    if (res.code === 0) {
      orignIpList.value = res.data;
      const obj = {} as any;
      res.data.forEach((item: any) => {
        if (obj[item.loc]) {
          obj[item.loc].push(item.ip);
        } else {
          obj[item.loc] = [item.ip];
        }
      });
      ipData.transformIpList = obj;
      ipData.localList = Object.keys(obj).map(item => ({
        label: item,
        value: item,
      }));
    }
  });
};
const domainData = () => {
  getDomail(model.orgId).then(res => {
    if (res.code === 0) {
      ipData.domainList = res.data.map(item => ({
        label: item.name,
        value: item.name,
      }));
    }
  });
};

const jumpApp = () => {
  const type = props.data.business;
  switch (type) {
    case 'WebPush':
      location.href = `/console/web-push/#/web-push/${model.orgId}`;
      break;
    case 'AppPush':
      location.href = `/console/app-push/#/app-push/${model.orgId}`;
      break;
    default:
      location.href = `/console/${type.toLowerCase()}/#/${type.toLowerCase()}/${model.orgId}`;
  }
};
const isShowCreate = computed(() => {
  return !['Email', 'SMS'].includes(props.data.business) && !appList.value.length;
});

GetOrganizationList();

watch(
  () => props.visible,
  () => {
    if (props.visible) {
      visible.value = props.visible;
    }
  },
  {
    immediate: true,
  },
);

watch(
  () => model.orgId,
  (val: string) => {
    if (val) {
      CreateGetAppsListApi();
      Object.assign(ipData, getDefaultValue());
      if (props.data.business === 'Email' && props.data.emailOrderDetail?.ipPackageNum) {
        ipData.ipList = new Array(props.data.emailOrderDetail?.ipPackageNum).fill({
          service: '3', // 独立IP，第1个
          domain: '', // Domain
          ipArea: '', // IP geolocation
          ip: '', // IP Address
          ipId: '',
        });
        domainData();
        console.log(model.orgId, 7777);
        getIpData();
      } else {
        ipData.ipList = [];
      }
    }
  },
  {
    immediate: true,
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal), {
    "mask-closable": false,
    visible: visible.value,
    "confirm-loading": loading.value,
    "destroy-on-close": "",
    width: 660,
    "ok-text": 
      isShowCreate.value
        ? _unref(t)('aws.bind.modal.create', {
            appName: businessName.value,
          })
        : _unref(t)('app.profile.reset.confirm')
    ,
    onOk: handleOk,
    onCancel: _cache[2] || (_cache[2] = ($event: any) => (emits('update:visible', false)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('aws.order.title')), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('aws.order.information')), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("img", {
              src: require('@/assets/bill/a-svg.svg'),
              alt: ""
            }, null, 8, _hoisted_7),
            _createTextVNode(" " + _toDisplayString(_unref(t)('aws.order.id')), 1)
          ]),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.data.id), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("img", {
              src: require('@/assets/bill/a-svg.svg'),
              alt: ""
            }, null, 8, _hoisted_11),
            _createTextVNode(" " + _toDisplayString(_unref(t)('aws.order.product')), 1)
          ]),
          _createElementVNode("div", _hoisted_12, _toDisplayString(businessName.value), 1)
        ]),
        (['AppPush', 'WebPush'].includes(_ctx.data.business))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("img", {
                    src: require('@/assets/bill/a-svg.svg'),
                    alt: ""
                  }, null, 8, _hoisted_15),
                  _createTextVNode(" " + _toDisplayString(_unref(t)('aws.apppush.dataCenter')), 1)
                ]),
                _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.data.pushOrderDetail?.dcName), 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("img", {
                    src: require('@/assets/bill/a-svg.svg'),
                    alt: ""
                  }, null, 8, _hoisted_19),
                  _createTextVNode(" " + _toDisplayString(_unref(t)('aws.apppush.dau')), 1)
                ]),
                _createElementVNode("div", _hoisted_20, _toDisplayString((_ctx.data.pushOrderDetail?.dau || 0) * 10) + "K", 1)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("img", {
                    src: require('@/assets/bill/a-svg.svg'),
                    alt: ""
                  }, null, 8, _hoisted_23),
                  _createTextVNode(" " + _toDisplayString(_unref(t)('aws.apppush.vip')), 1)
                ]),
                _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(t)('aws.month', {
                number: _ctx.data.pushOrderDetail?.month,
              })), 1)
              ])
            ], 64))
          : (['SMS', 'WhatsApp', 'OTP', 'NEWSMS'].includes(_ctx.data.business))
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("img", {
                    src: require('@/assets/bill/a-svg.svg'),
                    alt: ""
                  }, null, 8, _hoisted_27),
                  _createTextVNode(" " + _toDisplayString(_unref(t)('aws.whatsapp.recharge.price')), 1)
                ]),
                _createElementVNode("div", _hoisted_28, "$" + _toDisplayString(_ctx.data.chargeMoney), 1)
              ]))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_29, _toDisplayString(_unref(t)('aws.choose.service')), 1),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("img", {
              src: require('@/assets/bill/e-svg.svg'),
              alt: ""
            }, null, 8, _hoisted_32),
            _createTextVNode(" " + _toDisplayString(_unref(t)('aws.choose.organization')), 1)
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createVNode(_unref(Select), {
              value: model.orgId,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((model.orgId) = $event)),
              bordered: false,
              "dropdown-match-select-width": false
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organizationList.value, (item) => {
                  return (_openBlock(), _createBlock(_unref(Select).Option, {
                    key: item.value,
                    value: item.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.label) + " (" + _toDisplayString(item.value) + ") ", 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value"])
          ])
        ]),
        (!['Email', 'SMS'].includes(_ctx.data.business))
          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("img", {
                  src: require('@/assets/bill/e-svg.svg'),
                  alt: ""
                }, null, 8, _hoisted_36),
                _createTextVNode(" " + _toDisplayString(_ctx.data.business === 'WhatsApp' ? _unref(t)('aws.choose.whatsapp') : _unref(t)('aws.choose.app')), 1)
              ]),
              _createElementVNode("div", _hoisted_37, [
                (appList.value?.length)
                  ? (_openBlock(), _createBlock(_unref(Select), {
                      key: 0,
                      value: model.appKey,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((model.appKey) = $event)),
                      bordered: false,
                      "dropdown-match-select-width": false
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appList.value, (item) => {
                          return (_openBlock(), _createBlock(_unref(Select).Option, {
                            key: item.value,
                            value: item.value
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.label) + " (" + _toDisplayString(item.value) + ") ", 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_38, [
                      _createVNode(_unref(ExclamationCircleFilled), { style: {"margin-right":"6px"} }),
                      _createTextVNode(" " + _toDisplayString(_unref(t)('aws.choose.nodata')), 1)
                    ]))
              ])
            ]))
          : _createCommentVNode("", true),
        (['Email'].includes(_ctx.data.business))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("img", {
                    src: require('@/assets/bill/e-svg.svg'),
                    alt: ""
                  }, null, 8, _hoisted_41),
                  _createTextVNode(" " + _toDisplayString(_unref(t)('aws.email')), 1)
                ]),
                _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.data.emailOrderDetail?.emailPackageNum), 1)
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("img", {
                    src: require('@/assets/bill/e-svg.svg'),
                    alt: ""
                  }, null, 8, _hoisted_45),
                  _createTextVNode(" " + _toDisplayString(_unref(t)('aws.email.flow')), 1)
                ]),
                _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.data.emailOrderDetail?.flowPackageNum), 1)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ipData.ipList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass(["form-item", { hasError: getVerificationStatus(item) }])
                }, [
                  _createVNode(IpSelect, {
                    value: ipData.ipList[index],
                    "onUpdate:value": ($event: any) => ((ipData.ipList[index]) = $event),
                    "domain-list": ipData.domainList,
                    "local-list": ipData.localList,
                    "transform-ip-list": ipData.transformIpList,
                    "disable-list": disableList.value,
                    "org-id": model.orgId
                  }, null, 8, ["value", "onUpdate:value", "domain-list", "local-list", "transform-ip-list", "disable-list", "org-id"])
                ], 2))
              }), 128))
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["visible", "confirm-loading", "ok-text"]))
}
}

})